import { updateMessagesParticipant } from "api/messages";
import { useMutation } from "react-query";

/**
 * Hook to update a messages_participants record via API.
 * Wraps a React Query mutation that sends a PATCH request to update participant fields.
 *
 * @param {Object} [options={}] - Optional react-query mutation options.
 * @returns {Object} An object with `updateParticipant` mutation function and react-query state.
 */
export const useUpdateMessagesParticipant = (options = {}) => {
  const { mutate, ...rest } = useMutation(updateMessagesParticipant, options);

  return {
    updateParticipant: mutate,
    ...rest,
  };
};
